export default __webpack_public_path__ + "static/media/PrivacyPolicy.95a34669.svg";